export default {
      id: "weather__empty-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#weather__empty",
      toString: function () {
        return this.url;
      }
    }